import { useEffect, useState } from 'react';
import type { ActionSurfaceCopy } from './action-surface-copy';

/** The server remains authoritative; the clock only removes stale approval controls. */
export function useActionExpiry(expiresAt: string) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(timer);
  }, [expiresAt]);
  const remaining = Date.parse(expiresAt) - now;
  return {
    expired: !Number.isFinite(remaining) || remaining <= 0,
    near: remaining > 0 && remaining <= 300_000,
  };
}
export function ActionExpiry({
  expiresAt,
  copy,
  locale,
  id,
  near = false,
}: {
  expiresAt: string;
  copy: ActionSurfaceCopy;
  locale: string;
  id?: string;
  near?: boolean;
}) {
  const time = new Date(expiresAt).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
  });
  const label = copy.expiresAt(time);
  return (
    <span id={id} className={near ? 'pc-action-expiry' : 'sr-only'} title={label}>
      {label}
    </span>
  );
}
